<template>
  <v-dialog v-model="value" persistent max-width="1200px">
    <material-card color="orange" title="Email">
      <v-container py-0>
        <v-layout wrap>


          <v-flex v-if="loadedItem.to" xs3 md3 style="margin-top:15px">
            <h4>TO :</h4>
            <p>{{ loadedItem.to }}</p>
          </v-flex>

          <v-flex v-if="item.cc" xs3 md3 style="margin-top:15px">
            <h4>CC :</h4>
            <p>{{ loadedItem.cc }}</p>
          </v-flex>

          <v-flex v-if="loadedItem.bcc" xs3 md3 style="margin-top:15px">
            <h4>BCC :</h4>
            <p>{{ loadedItem.bcc }}</p>
          </v-flex>

          <v-flex v-if="loadedItem.subject" xs3 md3 style="margin-top:15px">
            <h4>Subject :</h4>
            <p>{{ loadedItem.subject }}</p>
          </v-flex>

          <v-flex xs12 md12 style="margin-top:15px">
            <iframe :srcdoc="loadedItem.body" @load="handleIframeLoad" ref="iframe" width="100%" height="450px"
              style=" overflow-y: scroll;border:0px solid orange">
            </iframe>
          </v-flex>

          <v-flex xs12 md12 style="margin-top:15px">

            <v-btn v-for="att in loadedItem.email_has_attachment" :key="att.attachment_id" @click="download(att)">
              {{ att.attachment.filename }}
            </v-btn>

          </v-flex>

          <v-flex xs12 text-right>
            <v-btn class="mx-1 font-weight-light" color="primary" @click="close()">Close</v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>

import { getDetail } from '@/api/base_entity.js'
import { downloadPdf } from '@/api/email.js'

export default {
  props: {
    value: { type: Boolean, default: true },
    item: { type: Object, default: () => { } },
  },
  data: () => ({
    loadedItem: {}
  }),
  watch: {
    value(v) {
      if (v) {
        getDetail('email', this.item.id, { 'x-foreign-levels': 2 }).then(data => {
          this.loadedItem = data
        })
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false)
    },
    download(item) {

      downloadPdf(item.attachment.filename)

      // var anchor = document.createElement('a');
      // anchor.href = process.env.VUE_APP_BASE_API + '/download_attachment/' + item.attachment.filename;
      // anchor.download = process.env.VUE_APP_BASE_API + '/download_attachment/' + item.attachment.filename;
      // document.body.appendChild(anchor);
      // anchor.click();
    },
    handleIframeLoad() {
      const iframe = this.$refs.iframe;
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      const links = iframeDocument.querySelectorAll('a');
      links.forEach(link => {
        link.setAttribute('target', '_blank');
      });
    }
  },

}
</script>


<style>
.preview {
  overflow-y: scroll;
  height: min(700px, 70vh);
}
</style>